import { useAuthFlowStore } from '@/features/auth/model/use-auth-flow-store';
import { AuthSteps } from '@/features/auth/ui/auth-steps';
import BottomSheet from '@/shared/ui/bottom-sheet';
import { Stack } from '@chakra-ui/react';

type Props = {
  open: boolean;
  onClose: () => void;
  onLastConfirm?: () => void;
};

const AuthWidget: React.FC<Props> = ({ open, onClose, onLastConfirm }) => {
  const { clearStore } = useAuthFlowStore();

  const handleSuccess = () => {
    clearStore(); // clear auth flow
    onClose(); // close BottomSheet
    if (onLastConfirm) onLastConfirm(); // callback after auth
  };

  const onCloseBottomSheet = () => {
    clearStore();
    onClose();
  };
  return (
    <BottomSheet isOpen={open} onClose={onCloseBottomSheet}>
      <Stack px={4} flex={1}>
        <AuthSteps onSuccess={handleSuccess} />
      </Stack>
    </BottomSheet>
  );
};

export default AuthWidget;
